// removed by extract-text-webpack-plugin
module.exports = {"paleSignificantDigit":"_29qgFM2R_nb3uXFI4WoRMr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisSignificantDigits.scss
// module id = 1137
// module chunks = 0